const TAU = Math.PI * 2;
const SPIN_INTERVAL = 10;
const SPIN_DURATION = 2.4;
const SPIN_WHEEL = {
  u: 384 / 1254,
  v: 579 / 1254,
  size: 88 / 1254
};
const ROULETTE_WHEEL = {
  u: 0.719,
  v: 0.447,
  radiusX: 0.052,
  radiusY: 0.023
};
const WATER_RIPPLES = [
  { u: 0.15, v: 0.18, phase: 0.04, scale: 1.05 },
  { u: 0.82, v: 0.16, phase: 0.42, scale: 0.88 },
  { u: 0.1, v: 0.46, phase: 0.72, scale: 1.16 },
  { u: 0.91, v: 0.4, phase: 0.18, scale: 0.92 },
  { u: 0.08, v: 0.74, phase: 0.53, scale: 0.78 },
  { u: 0.91, v: 0.72, phase: 0.84, scale: 1.12 },
  { u: 0.23, v: 0.91, phase: 0.28, scale: 0.95 },
  { u: 0.76, v: 0.93, phase: 0.64, scale: 1.06 }
];
const LAMP_LIGHTS = [
  { u: 0.419, v: 0.474, size: 1 },
  { u: 0.595, v: 0.474, size: 1 },
  { u: 0.414, v: 0.535, size: 0.9 },
  { u: 0.606, v: 0.535, size: 0.9 },
  { u: 0.431, v: 0.388, size: 0.82 },
  { u: 0.579, v: 0.389, size: 0.82 },
  { u: 0.404, v: 0.604, size: 0.82 },
  { u: 0.617, v: 0.604, size: 0.82 },
  { u: 0.4, v: 0.726, size: 0.9 },
  { u: 0.626, v: 0.726, size: 0.9 },
  { u: 0.31, v: 0.515, size: 0.78 },
  { u: 0.719, v: 0.514, size: 0.78 }
];
const NIGHT_BUILDING_LIGHTS = [
  {
    u: 0.365,
    v: 0.3,
    radiusX: 0.12,
    radiusY: 0.105,
    color: [61, 241, 176],
    warmth: [255, 209, 118],
    windows: [
      [-0.052, 0.01, 0.9],
      [0.052, 0.01, 0.9],
      [0, 0.064, 1.05]
    ]
  },
  {
    u: 0.64,
    v: 0.3,
    radiusX: 0.116,
    radiusY: 0.102,
    color: [85, 198, 255],
    warmth: [255, 211, 125],
    windows: [
      [-0.047, 0.012, 0.82],
      [0.048, 0.012, 0.82],
      [0, 0.062, 1]
    ]
  },
  {
    u: 0.307,
    v: 0.462,
    radiusX: 0.122,
    radiusY: 0.11,
    color: [255, 65, 145],
    warmth: [255, 199, 97],
    windows: [
      [-0.057, 0.008, 0.9],
      [0.057, 0.008, 0.9],
      [0, 0.066, 1.08]
    ]
  },
  {
    u: 0.719,
    v: 0.447,
    radiusX: 0.124,
    radiusY: 0.108,
    color: [255, 99, 74],
    warmth: [255, 211, 104],
    windows: [
      [-0.054, 0.013, 0.88],
      [0.054, 0.013, 0.88],
      [0, 0.064, 1.05]
    ]
  },
  {
    u: 0.374,
    v: 0.665,
    radiusX: 0.123,
    radiusY: 0.108,
    color: [184, 112, 255],
    warmth: [255, 211, 103],
    windows: [
      [-0.052, 0.005, 0.85],
      [0.052, 0.005, 0.85],
      [0, 0.061, 1.08]
    ]
  },
  {
    u: 0.67,
    v: 0.665,
    radiusX: 0.122,
    radiusY: 0.108,
    color: [183, 132, 255],
    warmth: [255, 190, 92],
    windows: [
      [-0.05, 0.009, 0.82],
      [0.05, 0.009, 0.82],
      [0, 0.06, 1.08]
    ]
  },
  {
    u: 0.5,
    v: 0.505,
    radiusX: 0.137,
    radiusY: 0.112,
    color: [67, 224, 255],
    warmth: [255, 151, 73],
    windows: [
      [-0.067, 0.004, 0.92],
      [0.067, 0.004, 0.92],
      [0, 0.073, 1.2]
    ]
  }
];

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

function lerp(start, end, amount) {
  return start + (end - start) * amount;
}

function easeInOut(amount) {
  const value = clamp(amount, 0, 1);
  return value < 0.5 ? 2 * value * value : 1 - Math.pow(-2 * value + 2, 2) / 2;
}

function easeOutCubic(amount) {
  const value = clamp(amount, 0, 1);
  return 1 - Math.pow(1 - value, 3);
}

function roundedRect(context, x, y, width, height, radius) {
  const safeRadius = Math.min(radius, width / 2, height / 2);
  context.beginPath();
  context.moveTo(x + safeRadius, y);
  context.arcTo(x + width, y, x + width, y + height, safeRadius);
  context.arcTo(x + width, y + height, x, y + height, safeRadius);
  context.arcTo(x, y + height, x, y, safeRadius);
  context.arcTo(x, y, x + width, y, safeRadius);
  context.closePath();
}

function rgba(color, alpha) {
  return `rgba(${color[0]}, ${color[1]}, ${color[2]}, ${alpha})`;
}

export default class HubMapEngine {
  constructor(canvas, options = {}) {
    this.canvas = canvas;
    this.context = canvas.getContext("2d");
    this.locations = options.locations || [];
    this.onSelect = options.onSelect || (() => undefined);
    this.onMovement = options.onMovement || (() => undefined);
    this.onZoomChange = options.onZoomChange || (() => undefined);

    this.width = 390;
    this.height = 844;
    this.pixelRatio = 1;
    this.baseMapSize = 900;
    this.defaultZoom = 1.3;
    this.mapSize = 900 * this.defaultZoom;
    this.zoom = this.defaultZoom;
    this.minZoom = 0.9;
    this.maxZoom = this.defaultZoom * 1.6;
    this.mapImageUrl = options.mapImageUrl;
    this.nightMapImageUrl = options.nightMapImageUrl;
    this.spinWheelImageUrl = options.spinWheelImageUrl;
    this.nightSpinWheelImageUrl = options.nightSpinWheelImageUrl;
    this.mapImage = new Image();
    this.nightMapImage = new Image();
    this.spinWheelImage = new Image();
    this.nightSpinWheelImage = new Image();
    this.mapReady = false;
    this.mapFailed = false;
    this.nightMapReady = false;
    this.spinWheelReady = false;
    this.nightSpinWheelReady = false;
    this.nightCompositeTexture = null;
    this.lampGlowTexture = this.createRadialGlowTexture([
      [0, "rgba(255, 248, 194, 0.96)"],
      [0.18, "rgba(255, 199, 80, 0.66)"],
      [0.52, "rgba(255, 135, 34, 0.24)"],
      [1, "rgba(255, 111, 20, 0)"]
    ]);
    this.portalGlowTexture = this.createRadialGlowTexture([
      [0, "rgba(119, 255, 255, 0.65)"],
      [0.35, "rgba(13, 215, 255, 0.3)"],
      [1, "rgba(0, 136, 255, 0)"]
    ]);
    this.moonGlowTexture = this.createRadialGlowTexture([
      [0, "rgba(184, 217, 255, 0.34)"],
      [0.3, "rgba(112, 160, 255, 0.15)"],
      [1, "rgba(34, 68, 143, 0)"]
    ]);
    this.nightBlend = 0;
    this.nightBlendTarget = 0;
    this.nightTransition = null;

    this.time = 0;
    this.running = false;
    this.frameId = null;
    this.lastTimestamp = 0;
    this.frameInterval = 1000 / 30;
    this.hitAreas = [];
    this.selectedId = "play";
    this.hoveredId = "";
    this.pointer = { x: -1000, y: -1000 };
    this.camera = {
      x: 0,
      y: 0,
      minX: -260,
      maxX: 260,
      minY: -110,
      maxY: 110,
      limitX: 260,
      limitY: 110
    };
    this.gesture = null;
    this.activePointers = new Map();
    this.pinch = null;
    this.focusAnimation = null;

    this.handleFrame = this.handleFrame.bind(this);
    this.mapImage.decoding = "async";
    this.mapImage.onload = () => {
      this.mapReady = true;
      this.mapFailed = false;
      this.refreshNightCompositeTexture();
      this.render();
    };
    this.mapImage.onerror = () => {
      this.mapFailed = true;
      this.render();
    };
    this.mapImage.src = this.mapImageUrl;
    this.nightMapImage.decoding = "async";
    this.nightMapImage.onload = () => {
      this.nightMapReady = true;
      this.refreshNightCompositeTexture();
      this.render();
    };
    this.nightMapImage.onerror = () => {
      this.nightMapReady = false;
      this.render();
    };
    this.nightMapImage.src = this.nightMapImageUrl;
    this.spinWheelImage.decoding = "async";
    this.spinWheelImage.onload = () => {
      this.spinWheelReady = true;
      this.render();
    };
    this.spinWheelImage.onerror = () => {
      this.spinWheelReady = false;
    };
    this.spinWheelImage.src = this.spinWheelImageUrl;
    this.nightSpinWheelImage.decoding = "async";
    this.nightSpinWheelImage.onload = () => {
      this.nightSpinWheelReady = true;
      this.render();
    };
    this.nightSpinWheelImage.onerror = () => {
      this.nightSpinWheelReady = false;
    };
    this.nightSpinWheelImage.src = this.nightSpinWheelImageUrl;
  }

  resize(width, height, pixelRatio = 1) {
    this.width = Math.max(280, width);
    this.height = Math.max(520, height);
    this.pixelRatio = clamp(pixelRatio, 1, 2);
    this.canvas.width = Math.round(this.width * this.pixelRatio);
    this.canvas.height = Math.round(this.height * this.pixelRatio);
    this.canvas.style.width = `${this.width}px`;
    this.canvas.style.height = `${this.height}px`;
    this.context.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);

    this.baseMapSize = Math.max(
      this.width * 2.15,
      this.height * 1.12,
      this.width < 430 ? 806 : 900
    );
    this.minZoom = Math.min(
      1,
      (Math.max(this.width, this.height) + 8) / this.baseMapSize
    );
    this.zoom = clamp(this.zoom, this.minZoom, this.maxZoom);
    this.mapSize = this.baseMapSize * this.zoom;
    this.updateCameraLimits();
    this.notifyZoomChange();
    this.render();
  }

  updateCameraLimits() {
    const edgeGuard = 4;
    const halfOverflowX = (this.mapSize - this.width) / 2;
    const halfOverflowY = (this.mapSize - this.height) / 2;
    const verticalMapOffset = 16;

    this.camera.minX = -halfOverflowX + edgeGuard;
    this.camera.maxX = halfOverflowX - edgeGuard;
    this.camera.minY = -halfOverflowY + verticalMapOffset + edgeGuard;
    this.camera.maxY = halfOverflowY + verticalMapOffset - edgeGuard;
    this.camera.limitX = Math.max(
      Math.abs(this.camera.minX),
      Math.abs(this.camera.maxX)
    );
    this.camera.limitY = Math.max(
      Math.abs(this.camera.minY),
      Math.abs(this.camera.maxY)
    );
    this.camera.x = clamp(this.camera.x, this.camera.minX, this.camera.maxX);
    this.camera.y = clamp(this.camera.y, this.camera.minY, this.camera.maxY);
  }

  getZoomState() {
    const displayedZoom = this.zoom / this.defaultZoom;
    return {
      value: this.zoom,
      percent: Math.round(displayedZoom * 100),
      min: this.minZoom,
      max: this.maxZoom,
      canZoomIn: this.zoom < this.maxZoom - 0.005,
      canZoomOut: this.zoom > this.minZoom + 0.005
    };
  }

  notifyZoomChange() {
    this.onZoomChange(this.getZoomState());
  }

  setZoom(nextZoom, options = {}) {
    const targetZoom = clamp(nextZoom, this.minZoom, this.maxZoom);
    if (Math.abs(targetZoom - this.zoom) < 0.001) return false;

    const anchor = options.anchor || {
      x: this.width * 0.5,
      y: this.height * 0.42
    };
    const currentFrame = this.getMapFrame();
    const mapU =
      typeof options.mapU === "number"
        ? options.mapU
        : (anchor.x - currentFrame.x) / currentFrame.size;
    const mapV =
      typeof options.mapV === "number"
        ? options.mapV
        : (anchor.y - currentFrame.y) / currentFrame.size;

    if (this.focusAnimation) {
      this.focusAnimation = null;
      this.onMovement(false);
    }

    this.zoom = targetZoom;
    this.mapSize = this.baseMapSize * this.zoom;
    this.updateCameraLimits();

    const baseFrame = this.getMapFrame(false);
    this.camera.x = clamp(
      anchor.x - baseFrame.x - mapU * baseFrame.size,
      this.camera.minX,
      this.camera.maxX
    );
    this.camera.y = clamp(
      anchor.y - baseFrame.y - mapV * baseFrame.size,
      this.camera.minY,
      this.camera.maxY
    );

    this.notifyZoomChange();
    this.render();
    return true;
  }

  zoomBy(amount, anchor) {
    return this.setZoom(this.zoom + amount, { anchor });
  }

  zoomByPercent(amount, anchor) {
    return this.zoomBy(this.defaultZoom * amount, anchor);
  }

  start() {
    if (this.running) return;
    this.running = true;
    this.lastTimestamp = 0;
    this.frameId = requestAnimationFrame(this.handleFrame);
  }

  stop() {
    this.running = false;
    if (this.frameId) {
      cancelAnimationFrame(this.frameId);
      this.frameId = null;
    }
  }

  handleFrame(timestamp) {
    if (!this.running) return;
    if (!this.lastTimestamp) {
      this.lastTimestamp = timestamp;
      this.update(1 / 30);
      this.render();
      this.frameId = requestAnimationFrame(this.handleFrame);
      return;
    }

    const elapsed = timestamp - this.lastTimestamp;
    if (elapsed < this.frameInterval) {
      this.frameId = requestAnimationFrame(this.handleFrame);
      return;
    }

    this.lastTimestamp = timestamp - (elapsed % this.frameInterval);
    const delta = Math.min(elapsed / 1000, 0.05);
    this.update(delta);
    this.render();
    this.frameId = requestAnimationFrame(this.handleFrame);
  }

  advanceTime(milliseconds) {
    const steps = Math.max(1, Math.round(milliseconds / (1000 / 60)));
    for (let index = 0; index < steps; index += 1) {
      this.update(1 / 60);
    }
    this.render();
  }

  update(delta) {
    this.time += delta;
    this.updateNightTransition(delta);
    if (!this.focusAnimation) return;

    this.focusAnimation.progress += delta / this.focusAnimation.duration;
    const amount = easeInOut(this.focusAnimation.progress);
    this.camera.x = lerp(
      this.focusAnimation.fromX,
      this.focusAnimation.toX,
      amount
    );
    this.camera.y = lerp(
      this.focusAnimation.fromY,
      this.focusAnimation.toY,
      amount
    );

    if (this.focusAnimation.progress >= 1) {
      this.camera.x = this.focusAnimation.toX;
      this.camera.y = this.focusAnimation.toY;
      this.focusAnimation = null;
      this.onMovement(false);
    }
  }

  setNightMode(enabled, options = {}) {
    const target = enabled ? 1 : 0;
    this.nightBlendTarget = target;

    if (options.immediate) {
      this.nightBlend = target;
      this.nightTransition = null;
      this.render();
      return;
    }

    this.nightTransition = {
      from: this.nightBlend,
      to: target,
      progress: 0,
      duration: 2.4
    };
  }

  updateNightTransition(delta) {
    if (!this.nightTransition) return;

    this.nightTransition.progress += delta / this.nightTransition.duration;
    const amount = easeInOut(this.nightTransition.progress);
    this.nightBlend = lerp(
      this.nightTransition.from,
      this.nightTransition.to,
      amount
    );

    if (this.nightTransition.progress >= 1) {
      this.nightBlend = this.nightTransition.to;
      this.nightTransition = null;
    }
  }

  setSelected(id, options = {}) {
    const location = this.locations.find(item => item.id === id);
    if (!location) return;

    this.selectedId = id;
    if (options.immediate) {
      this.focusAnimation = null;
      this.onMovement(false);
      this.render();
      return;
    }

    const basePoint = this.projectLocation(location, false);
    const toX = clamp(
      this.width * 0.5 - basePoint.x,
      this.camera.minX,
      this.camera.maxX
    );
    const toY = clamp(
      this.height * 0.4 - basePoint.y,
      this.camera.minY,
      this.camera.maxY
    );

    if (
      Math.abs(toX - this.camera.x) < 2 &&
      Math.abs(toY - this.camera.y) < 2
    ) {
      this.camera.x = toX;
      this.camera.y = toY;
      this.onMovement(false);
      this.render();
      return;
    }

    this.focusAnimation = {
      fromX: this.camera.x,
      fromY: this.camera.y,
      toX,
      toY,
      progress: 0,
      duration: 0.62
    };
    this.onMovement(true);
  }

  getMapFrame(includeCamera = true) {
    return {
      x: (this.width - this.mapSize) / 2 + (includeCamera ? this.camera.x : 0),
      y:
        (this.height - this.mapSize) / 2 -
        16 +
        (includeCamera ? this.camera.y : 0),
      size: this.mapSize
    };
  }

  projectLocation(location, includeCamera = true) {
    const frame = this.getMapFrame(includeCamera);
    return {
      x: frame.x + location.mapU * frame.size,
      y: frame.y + location.mapV * frame.size
    };
  }

  pointerToCanvas(clientX, clientY, bounds) {
    return {
      x: ((clientX - bounds.left) / bounds.width) * this.width,
      y: ((clientY - bounds.top) / bounds.height) * this.height
    };
  }

  handlePointerMove(clientX, clientY, bounds, pointerId = 0) {
    const point = this.pointerToCanvas(clientX, clientY, bounds);
    this.pointer = point;

    if (this.activePointers.has(pointerId)) {
      this.activePointers.set(pointerId, point);
    }

    if (this.pinch && this.activePointers.size >= 2) {
      const [firstPoint, secondPoint] = [...this.activePointers.values()];
      const distance = Math.max(
        1,
        Math.hypot(secondPoint.x - firstPoint.x, secondPoint.y - firstPoint.y)
      );
      const midpoint = {
        x: (firstPoint.x + secondPoint.x) / 2,
        y: (firstPoint.y + secondPoint.y) / 2
      };
      this.setZoom(
        this.pinch.startZoom * (distance / this.pinch.startDistance),
        {
          anchor: midpoint,
          mapU: this.pinch.mapU,
          mapV: this.pinch.mapV
        }
      );
      this.hoveredId = "";
      this.canvas.style.cursor = "grabbing";
      return;
    }

    if (this.gesture) {
      const deltaX = point.x - this.gesture.startX;
      const deltaY = point.y - this.gesture.startY;
      if (!this.gesture.dragging && Math.hypot(deltaX, deltaY) > 7) {
        this.gesture.dragging = true;
        if (this.focusAnimation) {
          this.focusAnimation = null;
          this.onMovement(false);
        }
      }

      if (this.gesture.dragging) {
        this.camera.x = clamp(
          this.gesture.cameraX + deltaX,
          this.camera.minX,
          this.camera.maxX
        );
        this.camera.y = clamp(
          this.gesture.cameraY + deltaY,
          this.camera.minY,
          this.camera.maxY
        );
        this.hoveredId = "";
        this.canvas.style.cursor = "grabbing";
        return;
      }
    }

    const hovered = [...this.hitAreas]
      .reverse()
      .find(area => this.pointInsideArea(point.x, point.y, area));
    this.hoveredId = hovered ? hovered.id : "";
    this.canvas.style.cursor = hovered ? "pointer" : "grab";
  }

  handlePointerDown(clientX, clientY, bounds, pointerId = 0) {
    const point = this.pointerToCanvas(clientX, clientY, bounds);
    this.activePointers.set(pointerId, point);
    this.pointer = point;
    this.canvas.style.cursor = "grabbing";

    if (this.activePointers.size >= 2) {
      const [firstPoint, secondPoint] = [...this.activePointers.values()];
      const midpoint = {
        x: (firstPoint.x + secondPoint.x) / 2,
        y: (firstPoint.y + secondPoint.y) / 2
      };
      const frame = this.getMapFrame();
      this.pinch = {
        startDistance: Math.max(
          1,
          Math.hypot(secondPoint.x - firstPoint.x, secondPoint.y - firstPoint.y)
        ),
        startZoom: this.zoom,
        mapU: (midpoint.x - frame.x) / frame.size,
        mapV: (midpoint.y - frame.y) / frame.size
      };
      this.gesture = null;
      if (this.focusAnimation) {
        this.focusAnimation = null;
        this.onMovement(false);
      }
      return;
    }

    this.gesture = {
      startX: point.x,
      startY: point.y,
      cameraX: this.camera.x,
      cameraY: this.camera.y,
      dragging: false
    };
  }

  handlePointerUp(clientX, clientY, bounds, pointerId = 0) {
    const point = this.pointerToCanvas(clientX, clientY, bounds);
    if (this.activePointers.has(pointerId)) {
      this.activePointers.set(pointerId, point);
    }

    const wasPinching = Boolean(this.pinch);
    this.activePointers.delete(pointerId);
    if (wasPinching) {
      this.pinch = null;
      this.gesture = null;
      this.hoveredId = "";
      this.pointer = point;

      if (this.activePointers.size === 1) {
        const [remainingPoint] = this.activePointers.values();
        this.gesture = {
          startX: remainingPoint.x,
          startY: remainingPoint.y,
          cameraX: this.camera.x,
          cameraY: this.camera.y,
          dragging: true
        };
      } else {
        this.canvas.style.cursor = "grab";
      }
      return false;
    }

    if (!this.gesture) return false;

    const dragged = this.gesture.dragging;
    this.gesture = null;
    this.pointer = point;
    this.canvas.style.cursor = "grab";

    if (dragged) {
      this.hoveredId = "";
      return false;
    }

    const hit = [...this.hitAreas]
      .reverse()
      .find(area => this.pointInsideArea(point.x, point.y, area));
    if (!hit) return false;

    this.setSelected(hit.id);
    this.onSelect(hit.id);
    return true;
  }

  handlePointerCancel(pointerId = 0) {
    this.activePointers.delete(pointerId);
    this.gesture = null;
    this.pinch = null;
    this.hoveredId = "";
    this.pointer = { x: -1000, y: -1000 };
    this.canvas.style.cursor = "grab";
  }

  handlePointerLeave() {
    if (this.gesture || this.pinch) return;
    this.hoveredId = "";
    this.pointer = { x: -1000, y: -1000 };
    this.canvas.style.cursor = "grab";
  }

  pointInsideArea(x, y, area) {
    return (
      x >= area.x &&
      x <= area.x + area.width &&
      y >= area.y &&
      y <= area.y + area.height
    );
  }

  render() {
    const context = this.context;
    context.save();
    context.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
    context.clearRect(0, 0, this.width, this.height);

    this.drawOceanBackdrop(context);
    if (this.mapReady) {
      this.drawMap(context);
      this.drawNightAtmosphere(context);
      this.drawWaterRipples(context);
      this.drawLampGlows(context);
      this.drawSpinWheel(context);
      this.drawRouletteBall(context);
      this.drawLocations(context);
    } else {
      this.drawLoading(context);
    }
    this.drawScreenTreatment(context);

    context.restore();
  }

  drawOceanBackdrop(context) {
    const gradient = context.createLinearGradient(0, 0, 0, this.height);
    gradient.addColorStop(0, "#09b9d0");
    gradient.addColorStop(0.52, "#087ca7");
    gradient.addColorStop(1, "#062e4d");
    context.fillStyle = gradient;
    context.fillRect(0, 0, this.width, this.height);

    if (this.nightBlend > 0.001) {
      const nightGradient = context.createLinearGradient(0, 0, 0, this.height);
      nightGradient.addColorStop(0, "#020a24");
      nightGradient.addColorStop(0.55, "#041c45");
      nightGradient.addColorStop(1, "#020716");
      context.save();
      context.globalAlpha = this.nightBlend;
      context.fillStyle = nightGradient;
      context.fillRect(0, 0, this.width, this.height);
      context.restore();
    }
  }

  drawMap(context) {
    const frame = this.getMapFrame();
    const hasNightMap = this.nightMapReady;
    const isTwilight =
      hasNightMap && this.nightBlend > 0.001 && this.nightBlend < 0.999;
    const dayAlpha = !hasNightMap
      ? 1
      : this.nightBlend <= 0.5
      ? lerp(1, 0.08, this.nightBlend * 2)
      : 0;
    const nightAlpha =
      hasNightMap && this.nightBlend >= 0.5
        ? lerp(0.08, 1, (this.nightBlend - 0.5) * 2)
        : 0;

    context.save();
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    context.shadowColor = "rgba(0, 24, 42, 0.42)";
    context.shadowBlur = 34;

    if (isTwilight) {
      context.fillStyle = "#020916";
      context.fillRect(
        Math.round(frame.x),
        Math.round(frame.y),
        Math.round(frame.size),
        Math.round(frame.size)
      );
    }

    if (dayAlpha > 0.001) {
      context.globalAlpha = dayAlpha;
      context.drawImage(
        this.mapImage,
        Math.round(frame.x),
        Math.round(frame.y),
        Math.round(frame.size),
        Math.round(frame.size)
      );
    }

    if (nightAlpha > 0.001) {
      const nightSource = this.nightCompositeTexture || this.nightMapImage;
      context.globalAlpha = nightAlpha;
      context.shadowColor = "rgba(39, 91, 190, 0.4)";
      context.shadowBlur = 28;
      context.filter = this.nightCompositeTexture
        ? "none"
        : "brightness(1.12) saturate(1.4) contrast(1.1)";
      context.drawImage(
        nightSource,
        Math.round(frame.x),
        Math.round(frame.y),
        Math.round(frame.size),
        Math.round(frame.size)
      );
      context.filter = "none";
    }
    context.restore();
  }

  createRadialGlowTexture(stops) {
    const ownerDocument = this.canvas && this.canvas.ownerDocument;
    if (!ownerDocument) return null;

    const textureSize = 128;
    const radius = textureSize / 2;
    const texture = ownerDocument.createElement("canvas");
    texture.width = textureSize;
    texture.height = textureSize;
    const context = texture.getContext("2d");
    if (!context) return null;

    const gradient = context.createRadialGradient(
      radius,
      radius,
      0,
      radius,
      radius,
      radius
    );
    stops.forEach(stop => gradient.addColorStop(stop[0], stop[1]));
    context.fillStyle = gradient;
    context.fillRect(0, 0, textureSize, textureSize);
    return texture;
  }

  drawNightAtmosphere(context) {
    if (
      this.nightBlend < 0.01 ||
      !this.nightMapReady ||
      !this.moonGlowTexture
    ) {
      return;
    }

    const frame = this.getMapFrame();
    const moonX = frame.x + frame.size * 0.135;
    const moonY = frame.y + frame.size * 0.06;
    const glowRadius = frame.size * 0.105;
    const shimmer = 0.88 + Math.sin(this.time * 1.35) * 0.12;

    context.save();
    context.globalCompositeOperation = "screen";
    context.globalAlpha = this.nightBlend * shimmer;
    context.drawImage(
      this.moonGlowTexture,
      moonX - glowRadius,
      moonY - glowRadius,
      glowRadius * 2,
      glowRadius * 2
    );
    context.restore();
  }

  refreshNightCompositeTexture() {
    if (!this.mapReady || !this.nightMapReady) return;
    this.nightCompositeTexture = this.createNightCompositeTexture();
  }

  createNightCompositeTexture() {
    const ownerDocument = this.canvas && this.canvas.ownerDocument;
    if (!ownerDocument) return null;

    const textureSize = Math.max(
      1254,
      this.nightMapImage.naturalWidth || 0,
      this.nightMapImage.naturalHeight || 0
    );
    const texture = ownerDocument.createElement("canvas");
    const detail = ownerDocument.createElement("canvas");
    const mask = ownerDocument.createElement("canvas");
    texture.width = textureSize;
    texture.height = textureSize;
    detail.width = textureSize;
    detail.height = textureSize;
    mask.width = textureSize;
    mask.height = textureSize;

    const context = texture.getContext("2d");
    const detailContext = detail.getContext("2d");
    const maskContext = mask.getContext("2d");
    if (!context || !detailContext || !maskContext) return null;

    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    context.filter = "brightness(1.14) saturate(1.42) contrast(1.12)";
    context.drawImage(this.nightMapImage, 0, 0, textureSize, textureSize);
    context.filter = "none";

    detailContext.imageSmoothingEnabled = true;
    detailContext.imageSmoothingQuality = "high";
    detailContext.filter = "brightness(1.46) saturate(1.62) contrast(1.16)";
    detailContext.drawImage(this.nightMapImage, 0, 0, textureSize, textureSize);
    detailContext.globalCompositeOperation = "screen";
    detailContext.globalAlpha = 0.24;
    detailContext.filter = "brightness(1.04) saturate(1.52) contrast(1.12)";
    detailContext.drawImage(this.mapImage, 0, 0, textureSize, textureSize);
    detailContext.filter = "none";
    detailContext.globalAlpha = 1;
    detailContext.globalCompositeOperation = "source-over";

    NIGHT_BUILDING_LIGHTS.forEach(building => {
      const centerX = building.u * textureSize;
      const centerY = building.v * textureSize;
      const radiusX = building.radiusX * textureSize * 0.88;
      const radiusY = building.radiusY * textureSize * 0.88;

      maskContext.save();
      maskContext.translate(centerX, centerY);
      maskContext.scale(1, radiusY / radiusX);
      const detailMask = maskContext.createRadialGradient(
        0,
        0,
        radiusX * 0.08,
        0,
        0,
        radiusX
      );
      detailMask.addColorStop(0, "rgba(255, 255, 255, 1)");
      detailMask.addColorStop(0.52, "rgba(255, 255, 255, 0.96)");
      detailMask.addColorStop(0.76, "rgba(255, 255, 255, 0.62)");
      detailMask.addColorStop(0.92, "rgba(255, 255, 255, 0.18)");
      detailMask.addColorStop(1, "rgba(255, 255, 255, 0)");
      maskContext.fillStyle = detailMask;
      maskContext.fillRect(-radiusX, -radiusX, radiusX * 2, radiusX * 2);
      maskContext.restore();
    });

    detailContext.globalCompositeOperation = "destination-in";
    detailContext.drawImage(mask, 0, 0);
    detailContext.globalCompositeOperation = "source-over";

    context.globalAlpha = 0.78;
    context.drawImage(detail, 0, 0);
    context.globalAlpha = 1;
    context.globalCompositeOperation = "screen";

    NIGHT_BUILDING_LIGHTS.forEach(building => {
      const centerX = building.u * textureSize;
      const centerY = building.v * textureSize;
      const radiusX = building.radiusX * textureSize;
      const radiusY = building.radiusY * textureSize;

      context.save();
      context.translate(centerX, centerY);
      context.scale(1, radiusY / radiusX);
      const aura = context.createRadialGradient(
        0,
        0,
        radiusX * 0.04,
        0,
        0,
        radiusX
      );
      aura.addColorStop(0, rgba(building.warmth, 0.38));
      aura.addColorStop(0.2, rgba(building.color, 0.3));
      aura.addColorStop(0.5, rgba(building.color, 0.13));
      aura.addColorStop(0.78, rgba(building.color, 0.045));
      aura.addColorStop(1, rgba(building.color, 0));
      context.fillStyle = aura;
      context.fillRect(-radiusX, -radiusX, radiusX * 2, radiusX * 2);
      context.restore();

      building.windows.forEach(windowLight => {
        const windowX = (building.u + windowLight[0]) * textureSize;
        const windowY = (building.v + windowLight[1]) * textureSize;
        const radius = textureSize * 0.018 * windowLight[2];
        const glow = context.createRadialGradient(
          windowX,
          windowY,
          0,
          windowX,
          windowY,
          radius
        );
        glow.addColorStop(0, "rgba(255, 255, 226, 0.98)");
        glow.addColorStop(0.16, rgba(building.warmth, 0.9));
        glow.addColorStop(0.48, rgba(building.warmth, 0.32));
        glow.addColorStop(1, rgba(building.warmth, 0));
        context.fillStyle = glow;
        context.fillRect(
          windowX - radius,
          windowY - radius,
          radius * 2,
          radius * 2
        );
      });
    });

    context.globalAlpha = 1;
    context.globalCompositeOperation = "source-over";
    return texture;
  }

  drawWaterRipples(context) {
    const frame = this.getMapFrame();
    const lineColor = this.nightBlend > 0.5 ? "164, 222, 255" : "223, 253, 255";

    context.save();
    context.globalCompositeOperation = "screen";
    WATER_RIPPLES.forEach(ripple => {
      for (let ringIndex = 0; ringIndex < 2; ringIndex += 1) {
        const progress =
          (this.time * 0.22 + ripple.phase + ringIndex * 0.46) % 1;
        const radius = frame.size * ripple.scale * (0.008 + progress * 0.026);
        const alpha =
          Math.pow(1 - progress, 1.45) * lerp(0.25, 0.48, this.nightBlend);

        context.globalAlpha = alpha;
        context.strokeStyle = `rgb(${lineColor})`;
        context.lineWidth = Math.max(0.8, frame.size * 0.00125);
        context.beginPath();
        context.ellipse(
          frame.x + ripple.u * frame.size,
          frame.y + ripple.v * frame.size,
          radius,
          radius * 0.34,
          -0.08,
          0,
          TAU
        );
        context.stroke();
      }
    });
    context.restore();
  }

  drawLampGlows(context) {
    if (
      this.nightBlend < 0.03 ||
      !this.lampGlowTexture ||
      !this.portalGlowTexture
    ) {
      return;
    }

    const frame = this.getMapFrame();
    context.save();
    context.globalCompositeOperation = "screen";
    context.globalAlpha = this.nightBlend;

    LAMP_LIGHTS.forEach((lamp, index) => {
      const x = frame.x + lamp.u * frame.size;
      const y = frame.y + lamp.v * frame.size;
      const flicker =
        0.88 +
        Math.sin(this.time * 3.2 + index * 1.73) * 0.08 +
        Math.sin(this.time * 6.7 + index) * 0.04;
      const radius = frame.size * 0.027 * lamp.size * flicker;
      context.drawImage(
        this.lampGlowTexture,
        x - radius,
        y - radius,
        radius * 2,
        radius * 2
      );
    });

    const portalX = frame.x + frame.size * 0.5;
    const portalY = frame.y + frame.size * 0.51;
    const portalPulse = 0.94 + Math.sin(this.time * 2.25) * 0.06;
    const portalRadius = frame.size * 0.068 * portalPulse;
    context.drawImage(
      this.portalGlowTexture,
      portalX - portalRadius,
      portalY - portalRadius,
      portalRadius * 2,
      portalRadius * 2
    );
    context.restore();
  }

  getSpinState() {
    const cycle = this.time % SPIN_INTERVAL;
    const startAt = SPIN_INTERVAL - SPIN_DURATION;
    const active = cycle >= startAt;
    const progress = active ? (cycle - startAt) / SPIN_DURATION : 0;
    return {
      cycle,
      active,
      progress,
      angle: active ? easeOutCubic(progress) * TAU * 2 : 0
    };
  }

  drawSpinWheel(context) {
    if (!this.spinWheelReady) return;

    const frame = this.getMapFrame();
    const spin = this.getSpinState();
    const centerX = frame.x + SPIN_WHEEL.u * frame.size;
    const centerY = frame.y + SPIN_WHEEL.v * frame.size;
    const size = SPIN_WHEEL.size * frame.size;
    const drawSprite = (image, alpha) => {
      if (!image || alpha < 0.001) return;
      context.globalAlpha = alpha;
      context.drawImage(image, -size / 2, -size / 2, size, size);
    };

    context.save();
    context.translate(centerX, centerY);
    context.rotate(spin.angle);
    context.imageSmoothingEnabled = true;
    context.imageSmoothingQuality = "high";
    drawSprite(this.spinWheelImage, 1 - this.nightBlend);
    drawSprite(
      this.nightSpinWheelReady ? this.nightSpinWheelImage : this.spinWheelImage,
      this.nightBlend
    );
    context.restore();
  }

  drawRouletteBall(context) {
    const frame = this.getMapFrame();
    const angle = (this.time * 1.72 - Math.PI * 0.4) % TAU;
    const centerX = frame.x + ROULETTE_WHEEL.u * frame.size;
    const centerY = frame.y + ROULETTE_WHEEL.v * frame.size;
    const x = centerX + Math.cos(angle) * ROULETTE_WHEEL.radiusX * frame.size;
    const y = centerY + Math.sin(angle) * ROULETTE_WHEEL.radiusY * frame.size;
    const radius = clamp(frame.size * 0.0065, 3.5, 9);
    const ballGlow = context.createRadialGradient(
      x - radius * 0.3,
      y - radius * 0.35,
      radius * 0.08,
      x,
      y,
      radius
    );
    ballGlow.addColorStop(0, "#ffffff");
    ballGlow.addColorStop(0.38, "#fff4c7");
    ballGlow.addColorStop(0.72, "#e9d9a3");
    ballGlow.addColorStop(1, "#83662d");

    context.save();
    context.shadowColor =
      this.nightBlend > 0.5
        ? "rgba(255, 225, 135, 0.9)"
        : "rgba(31, 15, 5, 0.65)";
    context.shadowBlur = radius * (this.nightBlend > 0.5 ? 2.4 : 1.3);
    context.shadowOffsetY = radius * 0.6;
    context.fillStyle = ballGlow;
    context.beginPath();
    context.arc(x, y, radius, 0, TAU);
    context.fill();
    context.lineWidth = Math.max(0.7, radius * 0.14);
    context.strokeStyle = "rgba(255, 255, 255, 0.88)";
    context.stroke();
    context.restore();
  }

  drawLocations(context) {
    this.hitAreas = [];
    const orderedLocations = [...this.locations].sort((first, second) => {
      const firstSelected = first.id === this.selectedId ? 1 : 0;
      const secondSelected = second.id === this.selectedId ? 1 : 0;
      return firstSelected - secondSelected;
    });

    orderedLocations.forEach(location => {
      const point = this.projectLocation(location);
      this.drawLocationMarker(context, point, location);
    });
  }

  drawLocationMarker(context, point, location) {
    const withinMapView =
      point.x >= -82 &&
      point.x <= this.width + 82 &&
      point.y >= 88 &&
      point.y <= this.height - 142;
    if (!withinMapView) return;

    const selected = location.id === this.selectedId;
    const hovered = location.id === this.hoveredId;
    const pulse = 1 + Math.sin(this.time * 4.2) * 0.08;
    const liftX = location.markerOffsetX || 0;
    const liftY = location.markerOffsetY || -64;
    const labelWidth = selected ? 164 : 152;
    const labelHeight = selected ? 58 : 52;
    const labelCenterX = clamp(
      point.x + liftX,
      labelWidth / 2 + 10,
      this.width - labelWidth / 2 - 10
    );
    const labelCenterY = clamp(point.y + liftY, 126, this.height - 190);
    const labelX = labelCenterX - labelWidth / 2;
    const labelY = labelCenterY - labelHeight / 2;
    const badgeRadius = selected ? 18 : 16;
    const badgeCenterX = labelX + (selected ? 27 : 25);
    const textLeft = labelX + (selected ? 53 : 49);

    context.save();
    context.globalAlpha = selected ? 0.96 : hovered ? 0.84 : 0.62;
    context.strokeStyle = selected ? "#ffffff" : location.accent;
    context.lineWidth = selected ? 3 : 2;
    context.shadowColor = location.accent;
    context.shadowBlur = selected ? 18 : 9;
    context.beginPath();
    context.arc(point.x, point.y, (selected ? 28 : 22) * pulse, 0, TAU);
    context.stroke();

    context.globalAlpha = selected ? 0.28 : 0.16;
    context.fillStyle = location.accent;
    context.beginPath();
    context.arc(point.x, point.y, (selected ? 22 : 16) * pulse, 0, TAU);
    context.fill();
    context.restore();

    context.save();
    context.strokeStyle = selected
      ? location.accent
      : "rgba(255, 255, 255, 0.72)";
    context.lineWidth = selected ? 2.2 : 1.4;
    context.beginPath();
    context.moveTo(
      clamp(point.x, labelX + 18, labelX + labelWidth - 18),
      labelY + labelHeight + 2
    );
    context.lineTo(point.x, point.y - 22);
    context.stroke();

    context.shadowColor = selected ? location.glow : "rgba(2, 20, 35, 0.62)";
    context.shadowBlur = selected ? 22 : 15;
    context.shadowOffsetY = 6;
    roundedRect(context, labelX, labelY, labelWidth, labelHeight, 15);
    context.fillStyle = selected
      ? "rgba(5, 23, 38, 0.97)"
      : "rgba(7, 31, 49, 0.92)";
    context.fill();
    context.shadowColor = "transparent";
    context.lineWidth = selected ? 2 : 1;
    context.strokeStyle = selected
      ? location.accent
      : "rgba(255, 255, 255, 0.38)";
    context.stroke();

    const badgeGradient = context.createLinearGradient(
      badgeCenterX - badgeRadius,
      labelCenterY - badgeRadius,
      badgeCenterX + badgeRadius,
      labelCenterY + badgeRadius
    );
    badgeGradient.addColorStop(0, "#ffffff");
    badgeGradient.addColorStop(0.14, location.accent);
    badgeGradient.addColorStop(1, "rgba(8, 33, 49, 0.96)");
    context.fillStyle = badgeGradient;
    context.shadowColor = location.accent;
    context.shadowBlur = selected ? 14 : 8;
    context.beginPath();
    context.arc(badgeCenterX, labelCenterY, badgeRadius, 0, TAU);
    context.fill();
    context.shadowColor = "transparent";
    context.lineWidth = 1.2;
    context.strokeStyle = "rgba(255, 255, 255, 0.8)";
    context.stroke();

    context.fillStyle = "#ffffff";
    context.font = `${selected ? 17 : 15}px FontAwesome`;
    context.textAlign = "center";
    context.textBaseline = "middle";
    context.fillText(
      location.iconGlyph || location.symbol,
      badgeCenterX,
      labelCenterY + 0.5
    );

    context.fillStyle = location.accent;
    context.font = `${selected ? "800" : "700"} ${
      selected ? 13.5 : 12.5
    }px "Sukhumvit Set", sans-serif`;
    context.textAlign = "left";
    context.textBaseline = "middle";
    context.fillText(location.label, textLeft, labelCenterY - 8);

    context.fillStyle = selected
      ? "rgba(255, 255, 255, 0.9)"
      : "rgba(235, 248, 255, 0.78)";
    context.font = `${selected ? "650" : "600"} ${
      selected ? 9.5 : 9
    }px "Sukhumvit Set", sans-serif`;
    context.fillText(location.menuHint, textLeft, labelCenterY + 10);
    context.restore();

    this.hitAreas.push({
      id: location.id,
      x: labelX - 5,
      y: labelY - 5,
      width: labelWidth + 10,
      height: labelHeight + 10
    });
    if (
      point.x >= -42 &&
      point.x <= this.width + 42 &&
      point.y >= 48 &&
      point.y <= this.height - 116
    ) {
      this.hitAreas.push({
        id: location.id,
        x: point.x - 46,
        y: point.y - 46,
        width: 92,
        height: 92
      });
    }
  }

  drawLoading(context) {
    const centerX = this.width / 2;
    const centerY = this.height * 0.42;
    const radius = 22;

    context.save();
    context.strokeStyle = "rgba(255, 255, 255, 0.2)";
    context.lineWidth = 4;
    context.beginPath();
    context.arc(centerX, centerY, radius, 0, TAU);
    context.stroke();

    context.strokeStyle = "#ffe19a";
    context.lineCap = "round";
    context.beginPath();
    context.arc(
      centerX,
      centerY,
      radius,
      this.time * 3,
      this.time * 3 + Math.PI * 0.72
    );
    context.stroke();
    context.fillStyle = "rgba(255, 255, 255, 0.84)";
    context.font = '600 12px "Sukhumvit Set", sans-serif';
    context.textAlign = "center";
    context.fillText(
      this.mapFailed ? "โหลดแผนที่ไม่สำเร็จ" : "กำลังเปิดแผนที่...",
      centerX,
      centerY + 48
    );
    context.restore();
  }

  drawScreenTreatment(context) {
    const topShade = context.createLinearGradient(0, 0, 0, 155);
    topShade.addColorStop(0, "rgba(2, 19, 31, 0.48)");
    topShade.addColorStop(1, "rgba(2, 19, 31, 0)");
    context.fillStyle = topShade;
    context.fillRect(0, 0, this.width, 155);

    const bottomShade = context.createLinearGradient(
      0,
      this.height * 0.68,
      0,
      this.height
    );
    bottomShade.addColorStop(0, "rgba(2, 18, 30, 0)");
    bottomShade.addColorStop(1, "rgba(2, 18, 30, 0.62)");
    context.fillStyle = bottomShade;
    context.fillRect(0, this.height * 0.68, this.width, this.height * 0.32);
  }

  renderGameToText() {
    const frame = this.getMapFrame();
    const spin = this.getSpinState();
    const rouletteAngle = (this.time * 1.72 - Math.PI * 0.4) % TAU;
    return JSON.stringify({
      mode: "illustrated-hub-map",
      coordinateSystem:
        "Normalized square map coordinates; (0,0) is the top-left and (1,1) is the bottom-right.",
      selected: this.selectedId,
      map: {
        ready: this.mapReady,
        x: Number(frame.x.toFixed(1)),
        y: Number(frame.y.toFixed(1)),
        size: Number(frame.size.toFixed(1)),
        zoom: Number(this.zoom.toFixed(3)),
        zoomPercent: Math.round((this.zoom / this.defaultZoom) * 100),
        zoomRange: {
          min: Number(this.minZoom.toFixed(3)),
          max: Number(this.maxZoom.toFixed(3)),
          minPercent: Math.round((this.minZoom / this.defaultZoom) * 100),
          maxPercent: Math.round((this.maxZoom / this.defaultZoom) * 100)
        }
      },
      camera: {
        x: Number(this.camera.x.toFixed(1)),
        y: Number(this.camera.y.toFixed(1)),
        moving: Boolean(this.focusAnimation),
        bounds: {
          x: Number(this.camera.limitX.toFixed(1)),
          y: Number(this.camera.limitY.toFixed(1)),
          minX: Number(this.camera.minX.toFixed(1)),
          maxX: Number(this.camera.maxX.toFixed(1)),
          minY: Number(this.camera.minY.toFixed(1)),
          maxY: Number(this.camera.maxY.toFixed(1))
        }
      },
      ambience: {
        timeOfDay: this.nightBlend >= 0.5 ? "night" : "day",
        nightBlend: Number(this.nightBlend.toFixed(3)),
        target: this.nightBlendTarget === 1 ? "night" : "day",
        transitioning: Boolean(this.nightTransition),
        nightAssetReady: this.nightMapReady
      },
      effects: {
        waterRipples: {
          active: true,
          count: WATER_RIPPLES.length
        },
        lampGlows: {
          active: this.nightBlend > 0.03,
          count: LAMP_LIGHTS.length
        },
        rouletteBall: {
          active: true,
          angle: Number(rouletteAngle.toFixed(3))
        },
        spinWheel: {
          active: spin.active,
          intervalSeconds: SPIN_INTERVAL,
          cycleSeconds: Number(spin.cycle.toFixed(3)),
          progress: Number(spin.progress.toFixed(3)),
          angle: Number(spin.angle.toFixed(3)),
          spriteReady: this.spinWheelReady,
          nightSpriteReady: this.nightSpinWheelReady
        }
      },
      locations: this.locations.map(location => ({
        id: location.id,
        label: location.label,
        menuHint: location.menuHint,
        u: location.mapU,
        v: location.mapV,
        selected: location.id === this.selectedId
      }))
    });
  }
}
